import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import cx from 'classnames';
import { isEqual, cloneDeep } from 'lodash';
import { Form, FormGroup, Label, Col, Row, Button } from 'reactstrap';
import Modal from '../../../Basic/Modal';
import CommonLoad from '../../../Basic/Spin';
import Select from '../../../Basic/Select';
import Notification from '../../../Basic/Notification';
import { getSolutionsApi, getSolutionNoAccessUsersApi, assignUserApi, updateUserApi } from '../../api/solutionManagement.api';
import { UserGroup } from './UserGroup';

var UserModal = /*#__PURE__*/function (_Component) {
  _inherits(UserModal, _Component);

  var _super = _createSuper(UserModal);

  function UserModal(props) {
    var _this;

    _classCallCheck(this, UserModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onSolutionChange", function (selectItem) {
      if (!selectItem) {
        return;
      }

      var solutionId = selectItem.id,
          name = selectItem.name,
          hasSubscription = selectItem.hasSubscription;
      var _this$state = _this.state,
          solution = _this$state.solution,
          solutionToRoles = _this$state.solutionToRoles;
      var initOneUserInfo = {
        _id: 1,
        email: {
          value: '',
          isLoading: false,
          options: []
        },
        solutionRole: {
          value: '',
          isLoading: false,
          options: solutionId && solutionToRoles[solutionId],
          isMulti: !hasSubscription
        },
        subscription: {
          value: '',
          isLoading: false,
          options: [],
          isDisabled: !hasSubscription
        }
      };

      _this.setState({
        solution: _objectSpread(_objectSpread({}, solution), {}, {
          value: {
            id: solutionId,
            name: name
          }
        }),
        userInfoList: [initOneUserInfo],
        initOneUserInfo: initOneUserInfo
      }, function () {
        _this.getSolutionNoAccessUsers(solutionId);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "canReset", function () {
      var userInfoList = _this.state.userInfoList;

      var _userInfoList = _slicedToArray(userInfoList, 1),
          userInfo = _userInfoList[0];

      if (userInfoList.length > 1) {
        return false;
      } else {
        return isEqual(userInfo, _this.state.resetUserInfo);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "reset", function () {
      var _this$props = _this.props,
          userInfo = _this$props.userInfo,
          mode = _this$props.mode;
      var solution = _this.state.solution;

      _this.setState({
        solution: _objectSpread(_objectSpread({}, solution), {}, {
          value: mode === 'edit' ? {
            id: userInfo.solutionId,
            name: userInfo.solutionName
          } : null
        }),
        userInfoList: [_this.state.resetUserInfo],
        initOneUserInfo: _this.state.resetUserInfo
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getSolutions", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$state2, solution, initOneUserInfo, currentSolutionId, _yield$getSolutionsAp, solutionList, solutionToRoles, roleToSubscriptions;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$state2 = _this.state, solution = _this$state2.solution, initOneUserInfo = _this$state2.initOneUserInfo;
              currentSolutionId = solution && solution.value && solution.value.id || '';
              initOneUserInfo.solutionRole.isLoading = true;

              _this.setState({
                solution: _objectSpread(_objectSpread({}, solution), {}, {
                  isLoading: true
                }),
                initOneUserInfo: initOneUserInfo
              });

              _context.prev = 4;
              _context.next = 7;
              return getSolutionsApi();

            case 7:
              _yield$getSolutionsAp = _context.sent;
              solutionList = _yield$getSolutionsAp.solutionList;
              solutionToRoles = _yield$getSolutionsAp.solutionToRoles;
              roleToSubscriptions = _yield$getSolutionsAp.roleToSubscriptions;
              initOneUserInfo.solutionRole.isLoading = false;
              initOneUserInfo.solutionRole.options = solutionToRoles[currentSolutionId] || [];
              initOneUserInfo.subscription.options = initOneUserInfo.solutionRole.value ? roleToSubscriptions[initOneUserInfo.solutionRole.value.id] : [];

              _this.setState({
                solution: _objectSpread(_objectSpread({}, solution), {}, {
                  isLoading: false,
                  options: solutionList
                }),
                solutionToRoles: solutionToRoles,
                roleToSubscriptions: roleToSubscriptions,
                initOneUserInfo: initOneUserInfo,
                userInfoList: [initOneUserInfo]
              });

              if (_this.props.mode === 'edit') {
                _this.setState({
                  resetUserInfo: cloneDeep(initOneUserInfo)
                });
              }

              _context.next = 22;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](4);
              initOneUserInfo.solutionRole.isLoading = false;

              _this.setState({
                solution: _objectSpread(_objectSpread({}, _this.state.solution), {}, {
                  isLoading: false
                }),
                initOneUserInfo: initOneUserInfo
              });

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 18]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "getSolutionNoAccessUsers", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(solutionId) {
        var _this$state$userInfoL, userInfo, userList;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$state$userInfoL = _slicedToArray(_this.state.userInfoList, 1), userInfo = _this$state$userInfoL[0];
                userInfo.email.isLoading = true;

                _this.setState({
                  initOneUserInfo: userInfo
                });

                _context2.prev = 3;
                _context2.next = 6;
                return getSolutionNoAccessUsersApi(solutionId);

              case 6:
                userList = _context2.sent;
                userInfo.email.isLoading = false;
                userInfo.email.options = userList;

                _this.setState({
                  initOneUserInfo: userInfo
                });

                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](3);
                userInfo.email.isLoading = false;

                _this.setState({
                  initOneUserInfo: userInfo
                });

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 12]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "canSave", function () {
      var _this$props2 = _this.props,
          mode = _this$props2.mode,
          userInfo = _this$props2.userInfo;
      var userInfoList = _this.state.userInfoList;

      if (!userInfoList.length) {
        return false;
      }

      var _iterator = _createForOfIteratorHelper(userInfoList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var i = _step.value;

          if (!i.email.value.id) {
            return false;
          }

          if (!i.solutionRole.value.id) {
            return false;
          }

          if (!i.subscription.isDisabled && !i.subscription.value.id) {
            return false;
          }

          if (mode === 'edit' && i.solutionRole.value === userInfo.roles[0]) {
            return false;
          }

          if (mode === 'edit' && !i.solutionRole.isMulti && i.subscription.value.id === userInfo.subscriptions.id) {
            return false;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "onSave", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _this$state3, solution, userInfoList, _this$props3, mode, onSuccess, userInfo, prevSubscriptionId, result, currentSolutionName, _result, param;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$state3 = _this.state, solution = _this$state3.solution, userInfoList = _this$state3.userInfoList;
              _this$props3 = _this.props, mode = _this$props3.mode, onSuccess = _this$props3.onSuccess, userInfo = _this$props3.userInfo;
              prevSubscriptionId = userInfo.subscriptions && userInfo.subscriptions.id || '';
              result = userInfoList.map(function (i) {
                var email = i.email,
                    solutionRole = i.solutionRole,
                    subscription = i.subscription;
                var solutionRoleVal = [solutionRole.value.id]; // For user subscription case,
                // do NOT add role id to the solution role id list,
                // just add the subscription id to "UserSubscriptionIdsToBeUsed" or "UserSubscriptionIdsToBeUnlinked".
                // when add a new user to solution, there is no subscription to be unlinked, so "UserSubscriptionIdsToBeUnlinked" is a "[]"
                // when edit a user with subscription, both "UserSubscriptionIdsToBeUsed" and "UserSubscriptionIdsToBeUnlinked" should have their value

                return {
                  UserId: email.value.id,
                  SolutionId: solution && solution.value && solution.value.id,
                  RoleIds: subscription.value.id ? [] : solutionRoleVal,
                  UserSubscriptionIdsToBeUsed: [subscription.value.id || ''],
                  UserSubscriptionIdsToBeUnlinked: [mode === 'edit' && subscription.value.id !== prevSubscriptionId ? prevSubscriptionId : '']
                };
              });

              _this.setState({
                saveLoading: true
              });

              _context3.prev = 5;

              if (!(mode === 'add')) {
                _context3.next = 11;
                break;
              }

              _context3.next = 9;
              return assignUserApi(result);

            case 9:
              currentSolutionName = solution.value && solution.value.name || '';
              Notification.open({
                description: _this.props.translate('SFxAccountSettingsAssignUserSuccessMsg', String(userInfoList.length), currentSolutionName)
              });

            case 11:
              if (!(mode === 'edit')) {
                _context3.next = 16;
                break;
              }

              _result = _slicedToArray(result, 1), param = _result[0];
              _context3.next = 15;
              return updateUserApi(param);

            case 15:
              Notification.open({
                description: _this.props.translate('SFxAccountSettingsEditAssignUserSuccessMsg', userInfo.email)
              });

            case 16:
              _this.setState({
                saveLoading: false
              });

              onSuccess(solution && solution.value && solution.value.id || '');
              _context3.next = 23;
              break;

            case 20:
              _context3.prev = 20;
              _context3.t0 = _context3["catch"](5);

              _this.setState({
                saveLoading: false
              });

            case 23:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[5, 20]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "updateUserInfoList", function (userInfoList) {
      _this.setState({
        userInfoList: userInfoList
      });
    });

    var _this$props4 = _this.props,
        _userInfo = _this$props4.userInfo,
        _mode = _this$props4.mode;
    var _solutionId = _userInfo.solutionId,
        solutionName = _userInfo.solutionName,
        _email = _userInfo.email,
        id = _userInfo.id,
        roles = _userInfo.roles,
        subscriptions = _userInfo.subscriptions,
        _hasSubscription = _userInfo.hasSubscription;
    var isEdit = _mode === 'edit';
    var _initOneUserInfo = {
      _id: 1,
      email: {
        value: isEdit ? {
          id: id,
          email: _email
        } : '',
        isLoading: false,
        options: []
      },
      solutionRole: {
        value: roles ? roles[0] : '',
        isLoading: false,
        options: [],
        isMulti: !_hasSubscription
      },
      subscription: {
        value: subscriptions,
        isLoading: false,
        options: [],
        isDisabled: !_hasSubscription
      }
    };
    var resetUserInfo = cloneDeep(_initOneUserInfo);
    _this.state = {
      resetUserInfo: resetUserInfo,
      initOneUserInfo: _objectSpread({}, _initOneUserInfo),
      userInfoList: [_initOneUserInfo],
      saveLoading: false,
      solutionToRoles: {},
      roleToSubscriptions: {},
      solution: {
        value: isEdit ? {
          id: _solutionId,
          name: solutionName
        } : null,
        isLoading: false,
        options: []
      }
    };
    return _this;
  }

  _createClass(UserModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getSolutions();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          prefix = _this$props5.prefix,
          isOpen = _this$props5.isOpen,
          onToggle = _this$props5.onToggle,
          mode = _this$props5.mode,
          translate = _this$props5.translate;
      var _this$state4 = this.state,
          initOneUserInfo = _this$state4.initOneUserInfo,
          userInfoList = _this$state4.userInfoList,
          saveLoading = _this$state4.saveLoading,
          solution = _this$state4.solution,
          roleToSubscriptions = _this$state4.roleToSubscriptions;
      var footer = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "reset-text"
      }, /*#__PURE__*/React.createElement("span", {
        onClick: this.reset,
        className: "reset-button ".concat(this.canReset() && 'reset-disabled', " ")
      }, translate('SFxAccountSettingsResetButtonText'))), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, {
        color: "secondary",
        onClick: onToggle
      }, translate('SFxAccountSettingsCancelButtonText')), /*#__PURE__*/React.createElement(Button, {
        disabled: !this.canSave(),
        color: "primary",
        onClick: this.onSave
      }, translate('SFxAccountSettingsSaveButtonText'))));
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
        centered: true,
        backdrop: "static",
        className: cx("account-settings-modal", 'solution-modal'),
        title: translate('SFxAccountSettingsSolutionAssignUserModalTitle'),
        isOpen: isOpen,
        toggle: onToggle,
        footer: footer
      }, saveLoading && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-mask")
      }, /*#__PURE__*/React.createElement(CommonLoad, {
        size: 0.2
      })), /*#__PURE__*/React.createElement("h3", null, translate('SFxAccountSettingsSolutionAssignUserModalTitle')), /*#__PURE__*/React.createElement("div", {
        className: "solution-modal-body"
      }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Row, {
        className: "solution-row"
      }, /*#__PURE__*/React.createElement(Col, {
        sm: "4"
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, translate('SFxAccountSettingsSolutionModalSolutionLabel')), /*#__PURE__*/React.createElement(Select, {
        isLoading: solution.isLoading,
        isDisabled: mode === 'edit',
        value: solution.value,
        options: solution.options,
        renderOption: function renderOption(i) {
          return {
            label: i.name,
            value: i.id
          };
        },
        onChange: this.onSolutionChange
      })))), /*#__PURE__*/React.createElement(UserGroup, {
        translate: translate,
        initOneUserInfo: initOneUserInfo,
        userInfoList: userInfoList,
        roleToSubscriptions: roleToSubscriptions,
        mode: mode,
        updateUserInfoList: this.updateUserInfoList
      })))));
    }
  }]);

  return UserModal;
}(Component);

export default UserModal;